import { Alert, Text } from "@mantine/core";

interface HeldEmailCancellationDetailsProps {
  cancelledAt: string | null;
  cancelledByUserName: string | null;
}

export function HeldEmailCancellationDetails({
  cancelledAt,
  cancelledByUserName,
}: HeldEmailCancellationDetailsProps) {
  if (!cancelledAt) return null;
  return (
    <Alert color="gray" title="Cancelled">
      <Text size="sm">
        Cancelled by {cancelledByUserName ?? "an unknown user"} on{" "}
        {new Date(cancelledAt).toLocaleString()}.
      </Text>
    </Alert>
  );
}
